// Pure helper for the Floor Plan Editor "Add Table" modal.
//
// Kept in its own module (no React/UI imports) so the create-table contract
// can be unit-tested in isolation. See GitHub issue #72: the floor-plan Add
// Table modal never collected a floor/section, so every table created from
// the editor landed on the API's default floor and the "Select section"
// filter dropdown could only ever show that single value.

import type { CreateTablePayload, TableShape } from '@/services/table.service';

export interface BuildCreateTableInput {
  tableNumber: string;
  seatingCapacity: number;
  shape: TableShape;
  floor?: string;
  locationId: string;
}

// Build the create-table request body. The floor/section is what populates
// the "Select section" filter dropdown (sections are derived from each
// table's floor). Only send `floor` when the user actually provided one — a
// blank value lets the API apply its own default rather than overwriting it
// with an empty string.
export function buildCreateTablePayload(input: BuildCreateTableInput): CreateTablePayload {
  const floor = input.floor?.trim();
  return {
    table_number: input.tableNumber.trim(),
    seating_capacity: input.seatingCapacity,
    shape: input.shape,
    location_id: input.locationId,
    ...(floor ? { floor } : {}),
  };
}
